import { ShopItemType, Sport } from '__generated__/globalTypes';

export const skins = [
  {
    id: 'bce37971-9cf4-4107-b40a-e40142c17212',
    pictureUrl: '/us-skin/nba/banners/bce37971-9cf4-4107-b40a-e40142c17212.png',
    bannerColor: '1F1F1F',
    sport: Sport.NBA,
    skinType: ShopItemType.BANNER,
    name: 'Dark Knight',
  },
  {
    id: '9bd94adb-83a3-4824-b0f6-4cee21bf0d8f',
    pictureUrl: '/us-skin/nba/banners/9bd94adb-83a3-4824-b0f6-4cee21bf0d8f.png',
    bannerColor: '5F5F5F',
    sport: Sport.NBA,
    skinType: ShopItemType.BANNER,
    name: 'Slate Gray',
  },
  {
    id: '0446fb41-b674-4c5c-886c-3812a1fdf001',
    pictureUrl: '/us-skin/nba/banners/0446fb41-b674-4c5c-886c-3812a1fdf001.png',
    bannerColor: '7332DD',
    sport: Sport.NBA,
    skinType: ShopItemType.BANNER,
    name: 'Royal Purple',
  },
  {
    id: '76807a52-69ee-4e8f-a2f6-a09aae58b1f5',
    pictureUrl: '/us-skin/nba/banners/76807a52-69ee-4e8f-a2f6-a09aae58b1f5.png',
    bannerColor: 'E66540',
    sport: Sport.NBA,
    skinType: ShopItemType.BANNER,
    name: 'Tangerine Blaze',
  },
  {
    id: '0e7795eb-dbee-4470-b8ab-131b52f4c0d2',
    pictureUrl: '/us-skin/nba/shields/0e7795eb-dbee-4470-b8ab-131b52f4c0d2.png',
    sport: Sport.NBA,
    skinType: ShopItemType.SHIELD,
    name: 'Blue Guardian',
  },
  {
    id: 'dfcae5b1-1915-40ca-ae9a-d9d3db7648b6',
    pictureUrl: '/us-skin/nba/shields/dfcae5b1-1915-40ca-ae9a-d9d3db7648b6.png',
    sport: Sport.NBA,
    skinType: ShopItemType.SHIELD,
    name: 'Silver Sentinel',
  },
  {
    id: '868794eb-3cc1-4e97-a887-e0b61a47970b',
    pictureUrl: '/us-skin/nba/shields/868794eb-3cc1-4e97-a887-e0b61a47970b.png',
    sport: Sport.NBA,
    skinType: ShopItemType.SHIELD,
    name: 'Golden Defender',
  },
  {
    id: '4dd9a42b-7328-4b3e-ade0-f08c127c991c',
    pictureUrl: '/us-skin/mlb/banners/4dd9a42b-7328-4b3e-ade0-f08c127c991c.png',
    bannerColor: '1F1F1F',
    sport: Sport.BASEBALL,
    skinType: ShopItemType.BANNER,
    name: 'Midnight Baseball',
  },
  {
    id: 'c440f08a-0f27-4706-8864-1e5b8dbf9b9f',
    pictureUrl: '/us-skin/mlb/banners/c440f08a-0f27-4706-8864-1e5b8dbf9b9f.png',
    bannerColor: '979797',
    sport: Sport.BASEBALL,
    skinType: ShopItemType.BANNER,
    name: 'Silver Slugger',
  },
  {
    id: 'f196b9f9-8cd6-4f44-bdf0-acb9b189ca85',
    pictureUrl: '/us-skin/mlb/banners/f196b9f9-8cd6-4f44-bdf0-acb9b189ca85.png',
    bannerColor: 'CF2065',
    sport: Sport.BASEBALL,
    skinType: ShopItemType.BANNER,
    name: 'Crimson Fireball',
  },
  {
    id: 'ebe458ce-b456-4fd0-9ed5-15c2911b5064',
    pictureUrl: '/us-skin/mlb/banners/ebe458ce-b456-4fd0-9ed5-15c2911b5064.png',
    bannerColor: '1A4DF2',
    sport: Sport.BASEBALL,
    skinType: ShopItemType.BANNER,
    name: 'Blue Lightning',
  },
  {
    id: '9fc1f7d9-1f4d-46d4-ac53-ba97954f5ee9',
    pictureUrl: '/us-skin/mlb/shields/9fc1f7d9-1f4d-46d4-ac53-ba97954f5ee9.png',
    sport: Sport.BASEBALL,
    skinType: ShopItemType.SHIELD,
    name: 'Guardian of the Infield',
  },
  {
    id: '55fd8d49-5e44-48e4-b4f1-9e4307a8da30',
    pictureUrl: '/us-skin/mlb/shields/55fd8d49-5e44-48e4-b4f1-9e4307a8da30.png',
    sport: Sport.BASEBALL,
    skinType: ShopItemType.SHIELD,
    name: 'Sentinel of the Outfield',
  },
  {
    id: '55151513-e5ea-4877-b70e-fa1560d16cc7',
    pictureUrl: '/us-skin/mlb/shields/55151513-e5ea-4877-b70e-fa1560d16cc7.png',
    sport: Sport.BASEBALL,
    skinType: ShopItemType.SHIELD,
    name: 'Skyward Catcher',
  },
];
